import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideTransLocoTranslate } from '@providers/transloco/transloco.provider';
import { provideTabDetectionAppWide } from '@providers/tab-detection/tab-detection.provider';
import { provideEnvironment } from '@providers/api-config/api-config.provider';
import { credentials } from '@app/interceptors/credentials';
import { loadingInterceptor } from '@app/interceptors/loading.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { errorInterceptor } from '@app/interceptors/error.interceptor';
import { providePortalBaseUrl } from './providers/portal-config/portal-config.provider';
import { provideFormsSecureUploadUrl } from './providers/forms-secure-upload-config/forms-secure-upload-config.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([credentials, loadingInterceptor, errorInterceptor])),
    provideEnvironment(),
    providePortalBaseUrl(),
    provideFormsSecureUploadUrl(),
    provideTransLocoTranslate(),
    provideTabDetectionAppWide(),
    provideAnimations(),
  ],
};
